import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=4bd2d008&"
import script from "./holiday.vue?vue&type=script&lang=js&"
export * from "./holiday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports